// extracted by css-extract-rspack-plugin
export default {"clickable":"JhL1k","text":"fNfAl"};